<template>
  <div class="page_wrapper">
    <div class="page_header">
      <prismic-image :field=" this.page.page_header_image" class="page_header_image page_header_image_desktop"/>
      <prismic-image :field=" this.page.page_header_image_mobile" class="page_header_image page_header_image_mobile"/>
      <div class="page_title">
        <h1>{{ $prismic.richTextAsPlain(this.page.page_title) }}</h1>
      </div>    
      <div class="page_small_description">
        {{ $prismic.richTextAsPlain(this.page.page_small_description) }}
      </div>
    </div><!-- end page header -->

    <div class="page_middle">
      <div class="page_big_title">
        {{ $prismic.richTextAsPlain(this.page.page_title) }}
      </div>

      <!-- icons -->
      <div class="page_icon_items">
        <div class="page_icon_item">
          <div class="page_icon"><prismic-image :field="this.page.page_icon_1"/></div>
          <div class="page_icon_title">{{ $prismic.richTextAsPlain(this.page.page_icon_title_1) }}</div>
        </div>
        <div class="page_icon_item">
          <div class="page_icon"><prismic-image :field="this.page.page_icon_2"/></div>
          <div class="page_icon_title">{{ $prismic.richTextAsPlain(this.page.page_icon_title_2) }}</div>
        </div>
        <div class="page_icon_item">
          <div class="page_icon"><prismic-image :field="this.page.page_icon_3"/></div>
          <div class="page_icon_title">{{ $prismic.richTextAsPlain(this.page.page_icon_title_3) }}</div>
        </div>
        <div class="page_icon_item">
          <div class="page_icon"><prismic-image :field="this.page.page_icon_4"/></div>
          <div class="page_icon_title">{{ $prismic.richTextAsPlain(this.page.page_icon_title_4) }}</div>
        </div>
        <div class="page_icon_item">
          <div class="page_icon"><prismic-image :field="this.page.page_icon_5"/></div>
          <div class="page_icon_title">{{ $prismic.richTextAsPlain(this.page.page_icon_title_5) }}</div>
        </div>                                
      </div>

      <div class="page_middle_content_wrapper">
        <div class="page_middle_content">
          <div class="page_big_description">
            <prismic-rich-text :field="this.page.page_big_description"/>
          </div>      
          <div class="page_image">
            <prismic-image :field="this.page.page_image"/>
          </div>
        </div><!-- end page middle content -->
      </div><!-- end page middle content wrapper -->
    </div><!-- end page middle -->

   <prednosti></prednosti>     

  </div><!-- end page wrapper -->
</template>

<script>
import $ from 'jquery'
import Prednosti from '../../components/Prednosti.vue'

export default {
  name: 'Streetfood',
  data () {
    return {
        page:[]
    }
  },
  methods: {
    getContent () {
         this.$prismic.client.getByUID('pages', 'street-food')
        .then((document) => {
          if (document) {
            this.page = document.data
            //loader
            $('.loader_wrapper').fadeOut('slow').promise().done(function(){ 
              $('.page_wrapper').fadeIn('slow');
            });            
          } else {
            this.$router.push({ name: 'not-found' })
          }
        })   
    }
  },
  mounted () {
    $(document).scrollTop(0);
    this.getContent();
    $('.page_wrapper').hide(); 
  },
  beforeCreate: function() {
      document.body.className = 'page';
      $('.loader_wrapper').css('display','flex');
  },
  components: {
    Prednosti
  }   
}
</script>